import React from "react";
import { Container, Row, Col, ButtonGroup } from "react-bootstrap";
import MyTeamBoard from "./Views/MyTeamVendors";
import MyTeam from "./Views/MyTeam";
import NewVendors from "./Views/NewVendors";
import { AllModules } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import NotesRenderer from "./Views/Renderers/NotesRenderer";
import ActionRenderer from "./Views/Renderers/ActionRenderer";
import ButtonRenderer from "./Views/Renderers/ButtonRenderer";
import StatusRenderer from "./Views/Renderers/StatusRenderer";
import * as Constants from "../../constants/Constants";
import AppContext from "../../context/appcontext";
import axios from "../../service/axios";
import Cookies from "js-cookie";
import "../../assets/css/template.css";
import { Button } from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import AddVendor from "./Views/AddNewVendor/AddVendorContainer";
import ReportsModal from "./Views/ReportsModal";
import PipelineContainer from "./Views/Pipeline/PipelineContainer";
import Preboarding from "./Views/Preboarding/Preboarding";
import AllVendors from "./Views/AllVendors/AllVendors";
import MyVendor from "./Views/MyVendor/MyVendor";
import AccessRequests from "./Views/AccessRequests/AccessRequests";
import EmailAdmin from "./Views/EmailAdmin/EmailAdmin";
import RetryFailure from "./Views/RetryFailer/RetryFailure";
import DBMApproval from "./Views/DBMApproval/DBMApproval";
import * as RolePermissionConstants from "../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../utils/rolePermissionAccess";
import {
  httpGetAdditionalAccessRequestForVendor,
  httpGetEmailAdmin,
  httpGetNewVendors,
  httpGetActivePipelineOwner,
  httpGetMerchantDashboard,
  httpGetRetryErrorList,
  httpPostRetryErrorById,
} from "../../service/httpClient";
import { convertDate } from "../../utils/DateUtility";
import MBEApproval from "../../components/Dashboard/Views/DBMApproval/MBEApproval";
import MBESendEmail from "../../components/Dashboard/Views/DBMApproval/MBESendEmail";

class Dashboard extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    const isHideColumn =
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYVENDORS,
        RolePermissionConstants.ACTIONS_CURRENTSTATUS_HIDE
      ) === RolePermissionConstants.VIEW;
    const isNavigationToDashboardOrMerchant =
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYVENDORS,
        RolePermissionConstants.VENDOR_NAME_NAVIGATION
      ) === RolePermissionConstants.VIEW;
    this.state = {
      openReportExportModal: false,
      isMyVendorLoading: false,
      isMyTeamLoading: false,
      isMyNewVendorLoading: false,
      accessRequests: [],
      isAccessRequests: false,
      emailAdmin: [],
      isEmailAdmin: false,
      modules: AllModules,
      disableQuickUpdate: true,
      myVendorsCount: 0,
      myTeamMembers: [],
      newVendor: [],
      pipeLineOwnerList: [],
      roleType: "",
      columnDefs: [
        {
          headerName: "Vendor Name",
          field: "vendorCorpName",
          width: 200,
          cellRenderer: function(params) {
            const { data = {} } = params || {};
            const {
              vendorProfileId = "",
              vendorCorpName = "",
              nextSteps = "",
            } = data || {};
            let newLink = "";
            if (isNavigationToDashboardOrMerchant) {
              newLink = (
                <a href={`/boarding/vendor/documentCenter`} target="_self">
                  {vendorCorpName}
                </a>
              );
            } else {
              newLink = (
                <a
                  href={`/boarding/vendor/company/${vendorProfileId}`}
                  target="_self"
                >
                  {vendorCorpName}
                </a>
              );

              if (
                nextSteps?.toLowerCase() ===
                Constants.VERBIAGE_DVN_AUDIT.toLowerCase()
              ) {
                newLink = (
                  <a
                    href={`/boarding/vendor/dvnaudit/${vendorProfileId}`}
                    target="_self"
                  >
                    {vendorCorpName}
                  </a>
                );
              } else if (
                nextSteps?.toLowerCase() === Constants.SETUP_DVN.toLowerCase()
              ) {
                newLink = (
                  <a
                    href={`/boarding/vendor/dvnsetup/${vendorProfileId}`}
                    target="_self"
                  >
                    {vendorCorpName}
                  </a>
                );
              }
            }

            return newLink;
          },
          comparator: stringDataComparator,
        },
        {
          headerName: "OpDiv",
          field: "sellingChannel",
          width: 180,
        },
        {
          headerName: "Vendor Fulfillment Type",
          field: "vendorFullFillmentType",
          width: 160,
        },
        {
          headerName: "Connection",
          field: "typeOfPlatform",
          width: 100,
        },
        {
          headerName: "Onboarding Phase",
          field: "onboardingPhase",
          width: 130,
        },
        {
          headerName: "Current Status",
          field: "currentStatus",
          width: 275,
          filter: false,
          sortable: false,
          hide: isHideColumn,
          cellRenderer: "statusRenderer",
        },
        {
          headerName: "Target Live Date",
          field: "liveDate",
          width: 120,
          comparator: dateComparator,
        },
        {
          headerName: "Next Action Date",
          field: "nextActionDate",
          width: 120,
          comparator: dateComparator,
        },
        {
          headerName: "Next Steps",
          field: "nextSteps",
          width: 130,
          cellRenderer: (params) => {
            if (params?.value === "Setup Dvn") {
              return "DVN Setup";
            }
            if (params?.value === "Dvn Audit") {
              return "DVN Audit";
            }
            return params?.value;
          },
        },
        {
          headerName: "Note",
          field: "vendorProfileId",
          width: 50,
          filter: false,
          sortable: false,
          cellRenderer: "notesRenderer",
        },
        {
          headerName: "Actions",
          field: "vendorProfileId",
          width: 200,
          cellRenderer: "buttonRenderer",
          filter: false,
          sortable: false,
          hide: isHideColumn,
          resizable: false,
        },
      ],
      columnDefsMerchant: [
        {
          headerName: "Vendor Name",
          field: "vendorCorpName",
          width: 200,
          cellRenderer: function(params) {
            const { data = {} } = params || {};
            const { vendorProfileId = "", vendorCorpName = "" } = data || {};
            let newLink = "";
            if (isNavigationToDashboardOrMerchant) {
              newLink = (
                <a href={`/boarding/vendor/documentCenter`} target="_self">
                  {vendorCorpName}
                </a>
              );
            } else {
              if (
                getUserRolePermission(
                  RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYTASKS,
                  RolePermissionConstants.HIDE
                ) === RolePermissionConstants.VIEW
              ) {
                newLink = (
                  <a
                    href={`/boarding/vendor/company/${vendorProfileId}`}
                    target="_self"
                  >
                    {vendorCorpName}
                  </a>
                );
              }
            }

            return newLink;
          },
          comparator: stringDataComparator,
        },
        {
          headerName: "Brand Name",
          field: "brandName",
          width: 130,
        },
        {
          headerName: "Duns",
          field: "duns",
          width: 130,
        },
        {
          headerName: "Vendor Fulfillment Type",
          field: "vendorFullFillmentType",
          width: 160,
        },
        {
          headerName: "Type of Vendor",
          field: "typeOfVendor",
          width: 130,
        },
        {
          headerName: "Vendor Connection",
          field: "typeOfPlatform",
          width: 130,
        },
        {
          headerName: "Annual Sales Volume",
          field: "annualSalesVolume",
          width: 150,
        },
        {
          headerName: " # of Documents",
          field: "numberOfDocuments",
          width: 130,
        },
        {
          headerName: "Onboarding Status",
          field: "onboardingStatus",
          width: 130,
        },
        {
          headerName: "Current Status",
          field: "currentStatus",
          width: 275,
          filter: false,
          sortable: false,
          hide: isHideColumn,
          cellRenderer: "statusRenderer",
        },
        {
          headerName: "Last Activity",
          field: "lastActivity",
          width: 130,
        },
        {
          headerName: "Last Activity Date",
          field: "lastActivityDate",
          width: 130,
        },
        {
          headerName: "Actions",
          field: "vendorProfileId",
          width: 200,
          cellRenderer: "buttonRenderer",
          filter: false,
          sortable: false,
          hide: isHideColumn,
          resizable: false,
        },
      ],
      paginationPageSize: 10,
      responseObject: [],
      defaultColDef: {
        lockVisible: true,
        suppressMovable: true,
        filter: true,
        sortable: true,
        resizable: true,
      },
      frameworkComponents: {
        notesRenderer: NotesRenderer,
        actionRenderer: ActionRenderer,
        buttonRenderer: ButtonRenderer,
        statusRenderer: StatusRenderer,
      },
      rowSelection: "multiple",
      getRowHeight: function(params) {
        return 33;
      },
      overlayNoRowsTemplate: "No Vendor available",
      activeTab:
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYVENDORS,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE
          ? Constants.MY_VENDORS
          : getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_DBMAPPROVAL,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE
          ? Constants.DBM_APPROVAL
          : Constants.MY_VENDORS,
      retryErrorList: [],
      retryErrorIsLoading: false,
      retryRequestError: "",
      retryRequestSuccess: "",
    };
  }

  componentDidMount() {
    this.setState({ isMyVendorLoading: true });
    this.showMyVendor();
  }

  showMyVendor = (val) => {
    httpGetMerchantDashboard(Cookies.get("email"))
      .then((response) => {
        const { data = {} } = response || {};
        const { roleType = "", dashboardVendorList = [] } = data || {};
        let frameworkComponents = { ...this.state.frameworkComponents };
        let columnDefs = [...this.state.columnDefs];
        let dashboardVendors = [];
        if (
          this.context.roles.roleName === "accountsPayableAdmin" ||
          this.context.roles.roleName === "accountsPayableAuditor" ||
          this.context.roles.roleName === "expensePayableAdmin"
        ) {
          frameworkComponents["buttonRenderer"] = (
            <ButtonRenderer roleName={this.context.roles.roleName} />
          );
        }
        if (roleType !== Constants.MERCHANT) {
          dashboardVendors = sortByVendorName(dashboardVendorList);
        } else {
          dashboardVendors = dashboardVendorList;
        }
        this.setState({
          responseObject: dashboardVendors,
          myVendorsCount: dashboardVendors?.length,
          frameworkComponents: frameworkComponents,
          columnDefs: columnDefs,
          isMyVendorLoading: false,
          roleType: roleType,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isMyVendorLoading: false });
      });
  };

  showVendor = (val) => {
    if (val === "showMyVendor") {
      this.setState(
        {
          isMyVendorLoading: true,
          activeTab: Constants.MY_VENDORS,
        },
        () => this.showMyVendor(val)
      );
    } else if (val === "showMyTeam") {
      this.setState(
        {
          isMyTeamLoading: true,
          activeTab: Constants.MY_TEAM,
        },
        () => this.showMyTeamVendor(val)
      );
    } else if (val === "showNewVendors") {
      this.setState(
        {
          isMyNewVendorLoading: true,
          activeTab: Constants.NEW_VENDORS,
        },
        () => this.showMyTeamVendor(val)
      );
    }
  };

  showMyTeamVendor = (val) => {
    if (val === "showMyTeam") this.getMyTeamList();
    if (val === "showNewVendors") {
      this.getPipeLineOwner();
      this.getNewVendorList();
    }
  };

  getMyTeamList = () => {
    httpGetActivePipelineOwner()
      .then((response) => {
        const { data = [], status } = response || {};
        if (status === 200 && data && data.length > 0) {
          this.setState({ myTeamMembers: data, isMyTeamLoading: false });
        } else {
          this.setState({ isMyTeamLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ isMyTeamLoading: false });
        console.log(error);
      });
  };

  getNewVendorList = () => {
    httpGetNewVendors()
      .then((response) => {
        const { data = [], status } = response || {};
        if (status === 200 && data && data.length > 0) {
          this.setState({ newVendor: data, isMyNewVendorLoading: false });
        } else {
          this.setState({ isMyNewVendorLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ isMyNewVendorLoading: false });
        console.log(error);
      });
  };

  getPipeLineOwner = () => {
    axios()
      .get("/admin/getAllUsersForPipeLineOwnerRole")
      .then((response) => {
        const { data = [], status } = response || {};

        if (status === 200 && data && data.length > 0) {
          this.setState({ pipeLineOwnerList: data });
        } else {
          this.setState({ isMyNewVendorLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ isMyNewVendorLoading: false });
        console.log(error);
      });
  };

  removedVendor = (vid) => {
    const newVendorArr = [...this.state.newVendor] || [];
    const removedVendorList =
      newVendorArr.filter((vendor) => vendor.id !== vid) || [];

    this.setState(
      { newVendor: removedVendorList, isMyTeamLoading: true },
      () => {
        this.getMyTeamList();
      }
    );
  };

  resetValue = () => {
    this.setState({ myTeamMembers: [], newVendor: [], pipeLineOwnerList: [] });
  };

  onToggleClassHandler = (value) => {
    return value === this.state.activeTab
      ? ["ButtonGroup btn-Dashboard-Clicked"]
      : ["ButtonGroup btn-Dashboard"];
  };

  toggleAddVendorModal = (val) => {
    if (val === "reportExport") {
      this.setState({
        openReportExportModal: !this.state.openReportExportModal,
        activeTab: Constants.REPORTS_EXPORTS,
      });
    }
  };

  getAccessDate = (accessDate) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let d = new Date(accessDate);
    let dd = d.getDate();
    const mm = months[d.getMonth()];
    const yyyy = d.getFullYear();

    if (dd < 10) {
      dd = "0" + dd;
    }

    d = mm + " " + dd + "," + yyyy;

    return d;
  };

  getAccessRequestDetail = () => {
    this.setState({ isAccessRequests: true }, () => {
      httpGetAdditionalAccessRequestForVendor()
        .then((response) => {
          const { data = [], status } = response || {};

          if (data && data?.length > 0 && status === 200) {
            let sortByDateResp = data.sort(
              (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
            );

            sortByDateResp.map((list) => {
              list.requestType =
                list.requestType === "ACCESS_REQUEST"
                  ? "Access Request"
                  : list.requestType === "NEW_REQUEST"
                  ? "New Vendor Record"
                  : "";
              list.createdDateView = this.getAccessDate(list.createdDate);
            });

            this.setState({ accessRequests: data, isAccessRequests: false });
          } else {
            this.setState({ isAccessRequests: false });
          }
        })
        .catch((error) => {
          this.setState({ isAccessRequests: false });
          console.log(error);
        });
    });
  };

  getRetryErrorList = () => {
    this.setState(
      {
        retryErrorIsLoading: true,
      },
      () => {
        httpGetRetryErrorList()
          .then((response) => {
            const { data = [] } = response;
            const updatedData = [];
            data.forEach((rec) => {
              let date = convertDate(rec.updatedDate);
              rec.updatedDate = date;
              updatedData.push(rec);
              if (rec.externalVendorId === "null") {
                rec.externalVendorId = "";
              }
            });
            let finalSortStatus = [];
            if (data && data.length > 0) {
              const filterBySortDateIsNull = updatedData.filter(
                (rep) => rep.updatedDate === null
              );
              const filterBySortDate = updatedData.filter(
                (rep) => rep.updatedDate !== null
              );
              const statusDetailSort = filterBySortDate.sort(
                (a, b) => new Date(b.updatedDate) - new Date(a.updatedDate)
              );
              finalSortStatus = [
                ...statusDetailSort,
                ...filterBySortDateIsNull,
              ];
            }
            this.setState({
              retryErrorList: finalSortStatus,
              retryErrorIsLoading: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              retryErrorList: [],
              retryErrorIsLoading: false,
            });
          });
      }
    );
  };

  retryRequestHandler = (data) => {
    this.setState(
      {
        retryErrorIsLoading: true,
        retryRequestError: "",
        retryRequestSuccess: "",
      },
      () => {
        httpPostRetryErrorById(data.id)
          .then((res) => {
            if (res && res.status === 200) {
              this.setState(
                {
                  retryRequestError: res.data.includes("Error") ? res.data : "",
                  retryRequestSuccess: !res.data.includes("Error")
                    ? res.data
                    : "",
                },
                () => this.getRetryErrorList()
              );
            } else {
              throw new Error("Something went wrong, try after sometime!");
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response && error.response.status === 400) {
              this.setState({
                retryRequestError:
                  error.response?.data?.message ||
                  "Something went wrong, try after sometime!",
                retryRequestSuccess: "",
              });
            } else {
              this.setState({
                retryRequestError: error.message,
                retryRequestSuccess: "",
              });
            }
          });
      }
    );
  };

  getEmailAdminDetail = () => {
    this.setState({ isEmailAdmin: true }, () => {
      httpGetEmailAdmin(this.context.roles.roleName)
        .then((response) => {
          const { data = [], status } = response || {};

          if (data && data?.length > 0 && status === 200) {
            let responseData = data;

            responseData.map((list) => {
              list.active =
                list.active === true
                  ? "Yes"
                  : list.active === false
                  ? "No"
                  : "";
              list.lastActivity =
                list.updatedDate !== null
                  ? convertDate(list.updatedDate)
                  : list.updatedDate;
            });
            this.setState({ emailAdmin: responseData, isEmailAdmin: false });
          } else {
            this.setState({ isEmailAdmin: false });
          }
        })
        .catch((error) => {
          this.setState({ isEmailAdmin: false });
          console.log(error);
        });
    });
  };

  render() {
    return (
      <Container fluid>
        {this.state.openReportExportModal && (
          <ReportsModal
            data-testid="MyVendor-reportModal"
            toggleModal={this.toggleAddVendorModal}
            dashboardYear={this.props.match.params.year}
          />
        )}

        <Row className="buttonDashboard">
          <ButtonGroup aria-label="DashboardTabs">
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYVENDORS,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="showMyVendor"
                variant="secondary"
                className={this.onToggleClassHandler(Constants.MY_VENDORS).join(
                  " "
                )}
                onClick={() => this.showVendor("showMyVendor")}
              >
                {Constants.MY_VENDORS}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_DBMAPPROVAL,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="dbmApproval"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.DBM_APPROVAL
                ).join(" ")}
                onClick={() =>
                  this.setState({
                    activeTab: Constants.DBM_APPROVAL,
                  })
                }
              >
                {Constants.DBM_APPROVAL}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_ALLVENDORS,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="showAllVendors"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.ALL_VENDORS
                ).join(" ")}
                onClick={() =>
                  this.setState({ activeTab: Constants.ALL_VENDORS })
                }
              >
                {Constants.ALL_VENDORS}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MBEWBEAPPROVAL,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="mbewbeApproval"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.MBE_WBE_VENDORS_APPROVAL
                ).join(" ")}
                onClick={() =>
                  this.setState({
                    activeTab: Constants.MBE_WBE_VENDORS_APPROVAL,
                  })
                }
              >
                {Constants.MBE_WBE_VENDORS_APPROVAL}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MBEWBESENDEMAIL,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="mbewbeSendEmail"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.MBE_WBE_SEND_EMAIL
                ).join(" ")}
                onClick={() =>
                  this.setState({
                    activeTab: Constants.MBE_WBE_SEND_EMAIL,
                  })
                }
              >
                {Constants.MBE_WBE_SEND_EMAIL}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_PREBOARDING,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="showPreboarding"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.PREBOARDING
                ).join(" ")}
                onClick={() =>
                  this.setState({ activeTab: Constants.PREBOARDING })
                }
              >
                {Constants.PREBOARDING}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_NEWVENDORS,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.NEW_VENDORS
                ).join(" ")}
                onClick={() => this.showVendor("showNewVendors")}
              >
                {Constants.NEW_VENDORS}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_ADDVENDOR,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                variant="secondary"
                className={this.onToggleClassHandler(Constants.ADD_VENDOR).join(
                  " "
                )}
                onClick={() =>
                  this.setState({ activeTab: Constants.ADD_VENDOR })
                }
              >
                {Constants.ADD_VENDOR}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_REPORTS,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.REPORTS_EXPORTS
                ).join(" ")}
                onClick={() => this.toggleAddVendorModal("reportExport")}
              >
                {Constants.REPORTS_EXPORTS}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_PIPELINE,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="showPipeline"
                variant="secondary"
                className={this.onToggleClassHandler(Constants.PIPELINE).join(
                  " "
                )}
                onClick={() => this.setState({ activeTab: Constants.PIPELINE })}
              >
                {Constants.PIPELINE}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYTEAM,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="showMyTeam"
                variant="secondary"
                className={this.onToggleClassHandler(Constants.MY_TEAM).join(
                  " "
                )}
                onClick={() => this.showVendor("showMyTeam")}
              >
                {Constants.MY_TEAM}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_ACCESSREQUESTS,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="showAccessRequests"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.ACCESS_REQUESTS
                ).join(" ")}
                onClick={() =>
                  this.setState(
                    {
                      activeTab: Constants.ACCESS_REQUESTS,
                    },
                    () => this.getAccessRequestDetail()
                  )
                }
              >
                {Constants.ACCESS_REQUESTS}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_EMAILADMIN,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="showEmailAdmin"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.EMAIL_ADMIN
                ).join(" ")}
                onClick={() =>
                  this.setState(
                    {
                      activeTab: Constants.EMAIL_ADMIN,
                    },
                    () => this.getEmailAdminDetail()
                  )
                }
              >
                {Constants.EMAIL_ADMIN}
              </Button>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MANAGE_MP_INBOUND,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <Button
                id="manageMPInbound"
                variant="secondary"
                className={this.onToggleClassHandler(
                  Constants.MANAGE_MP_INBOUND
                ).join(" ")}
                onClick={() =>
                  this.setState(
                    {
                      activeTab: Constants.MANAGE_MP_INBOUND,
                    },
                    () => this.getRetryErrorList()
                  )
                }
              >
                {Constants.MANAGE_MP_INBOUND}
              </Button>
            )}
          </ButtonGroup>
        </Row>
        {(getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYVENDORS,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE ||
          getUserRolePermission(
            RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYTASKS,
            RolePermissionConstants.HIDE
          ) === RolePermissionConstants.VIEW) &&
          this.state.activeTab === Constants.MY_VENDORS && (
            <>
              {getUserRolePermission(
                RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYTASKS,
                RolePermissionConstants.HIDE
              ) !== RolePermissionConstants.VIEW && (
                <MyTeamBoard workflowSteps={this.context.state.workflowSteps} />
              )}
              <LoadingOverlay active={this.state.isMyVendorLoading} spinner>
                <div className="myVendor">
                  <Row className="ribbon-black">
                    {Constants.MY_VENDORS} ({this.state.myVendorsCount})
                  </Row>
                  <MyVendor
                    columnDefs={
                      this.state.roleType === Constants.MERCHANT
                        ? this.state.columnDefsMerchant
                        : this.state.columnDefs
                    }
                    rowData={this.state.responseObject}
                    getRowHeight={this.state.getRowHeight}
                    defaultColDef={this.state.defaultColDef}
                    frameworkComponents={this.state.frameworkComponents}
                    modules={this.state.modules}
                    overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
                  />
                </div>
              </LoadingOverlay>
            </>
          )}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_ALLVENDORS,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE &&
          this.state.activeTab === Constants.ALL_VENDORS && <AllVendors />}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_PREBOARDING,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE &&
          this.state.activeTab === Constants.PREBOARDING && <Preboarding />}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MANAGE_MP_INBOUND,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE &&
          this.state.activeTab === Constants.MANAGE_MP_INBOUND && (
            <div>
              <RetryFailure
                responseData={this.state.retryErrorList}
                isLoading={this.state.retryErrorIsLoading}
                retryRequestHandler={this.retryRequestHandler}
                retryRequestError={this.state.retryRequestError}
                retryRequestSuccess={this.state.retryRequestSuccess}
              />
            </div>
          )}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_NEWVENDORS,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE &&
          this.state.activeTab === Constants.NEW_VENDORS && (
            <Row as={Col} md={12}>
              <NewVendors
                isMyNewVendorLoading={this.state.isMyNewVendorLoading}
                newVendor={this.state.newVendor}
                pipeLineOwnerList={this.state.pipeLineOwnerList}
                removedVendor={this.removedVendor}
                resetValue={this.resetValue}
              />
            </Row>
          )}
        {this.state.activeTab === Constants.ADD_VENDOR && <AddVendor />}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_PIPELINE,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE &&
          this.state.activeTab === Constants.PIPELINE && <PipelineContainer />}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYTEAM,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE &&
          this.state.activeTab === Constants.MY_TEAM && (
            <Row as={Col} md={12}>
              <MyTeam
                myTeamMembers={this.state.myTeamMembers}
                isMyTeamLoading={this.state.isMyTeamLoading}
              />
            </Row>
          )}
        {this.state.activeTab === Constants.ACCESS_REQUESTS && (
          <AccessRequests
            accessRequests={this.state.accessRequests}
            isAccessRequests={this.state.isAccessRequests}
            getAccessRequestDetail={this.getAccessRequestDetail}
          />
        )}
        {this.state.activeTab === Constants.EMAIL_ADMIN && (
          <EmailAdmin
            emailAdmin={this.state.emailAdmin}
            isEmailAdmin={this.state.isEmailAdmin}
            getEmailAdminDetail={this.getEmailAdminDetail}
          />
        )}
        {this.state.activeTab === Constants.DBM_APPROVAL && <DBMApproval />}
        {this.state.activeTab === Constants.MBE_WBE_VENDORS_APPROVAL && <MBEApproval />} 
        {this.state.activeTab === Constants.MBE_WBE_SEND_EMAIL && <MBESendEmail />}         
      </Container>
    );
  }
}

function dateComparator(date1, date2) {
  var date1Number = monthToComparableNumber(date1);
  var date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
function monthToComparableNumber(date) {
  if (date === undefined || date === null) {
    return null;
  }
  var yearNumber = date.substring(6, 10);
  var dateNumber = date.substring(3, 5);
  var monthNumber = date.substring(0, 2);
  var result = yearNumber + monthNumber + dateNumber;
  return result;
}
const sortByVendorName = (vendorList) => {
  vendorList.sort((a, b) => {
    let valueA = a.vendorCorpName;
    let valueB = b.vendorCorpName;
    return stringDataComparator(valueA, valueB); // Default order - ascending(A-Z)
  });
  return vendorList;
};
function stringDataComparator(valueA, valueB) {
  const valueALower =
    valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
  const valueBLower =
    valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
  if (valueALower && valueBLower) {
    return valueALower === valueBLower
      ? 0
      : valueALower.localeCompare(valueBLower, "en", { numeric: true });
  } else if (valueALower && (valueBLower === null || valueBLower === "")) {
    return -1;
  } else if ((valueALower === null || valueALower === "") && valueBLower) {
    return 1;
  } else {
    return -1;
  }
}

export default Dashboard;
